import { ITheme } from "../../Theme/Theme.types.js";
import { ButtonProps } from "../Button.types.js";

export const getGap = ({ size, theme }: { size: NonNullable<ButtonProps["size"]>; theme: ITheme }): string => {
    if (size === "small") return theme.spacing[8];
    if (size === "medium") return theme.spacing[12];
    return theme.spacing[12];
};
